module.exports = __webpack_public_path__ + "Roboto-Thin.woff2?ad538a69b0e8615ed0419c4529344ffc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/Thin/Roboto-Thin.woff2?v=2.137
// module id = 681
// module chunks = 7